import { execAdmin } from '@src/apis/reware/utils';

export interface RepairPriceCriteriaTag {
  tag: string;
  name: string;
}

export interface RepairPriceCriteria {
  id: number;
  locationAttributeName: string | null;
  problemAttributeName: string | null;
  severityAttributeName: string | null;
  price: number;
  rubricCode: string | null;
  vendorCountryCode: string | null;
  tags: RepairPriceCriteriaTag[];
}

export interface RepairPriceResult {
  uuid: string;
  criteria: RepairPriceCriteria[];
}

interface FetchRepairPricingVariables {
  partnerId: number;
}

interface FetchRepairPricingResponse {
  partner?: {
    repairPricing?: {
      uuid: string;
      criteria: RepairPriceCriteria[];
    } | null;
  };
}

export const fetchRepairPricing = async (partnerId: number): Promise<RepairPriceResult | null> => {
  const query = `
    query getRepairPricing($partnerId: Int!) {
      partner(id: $partnerId) {
        repairPricing {
          uuid
          criteria {
            id
            locationAttributeName
            problemAttributeName
            severityAttributeName
            price
            rubricCode
            vendorCountryCode
            tags { tag name }
          }
        }
      }
    }
  `;

  const data = await execAdmin<FetchRepairPricingVariables, FetchRepairPricingResponse>(
    query,
    { variables: { partnerId } },
  );

  return data.partner?.repairPricing ?? null;
};
